import styled from 'styled-components'

import { Text } from 'components/Text'

export const ClientListContainer = styled.div``
export const ClientListHeader = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 1rem 0;
  display: grid;
  grid-template:
    1fr / minmax(min-content, 122px) minmax(min-content, 210px) minmax(
      min-content,
      230px
    )
    minmax(min-content, 1fr) minmax(min-content, 120px);
  grid-gap: 0.5rem;
`
export const ClientListHeaderHead = styled(Text)`
  font-size: 1.125rem;
  line-height: 1.125rem;
  font-weight: 500;
`
export const ClientListContent = styled.div`
  margin: 0 0 4rem;
`
export const ClientListFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

//LISTITEM
export const ClientListItemContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  padding: 1.5rem 0;
  display: grid;
  grid-template:
    1fr / minmax(min-content, 122px) minmax(min-content, 210px) minmax(
      min-content,
      230px
    )
    minmax(min-content, 1fr) minmax(min-content, 120px);
  grid-gap: 0.5rem;
  &:hover {
    background-color: #f3f2ff;
  }
`
export const ClientListItemBody = styled.div<{ justify?: string }>`
  display: flex;
  align-items: center;
  justify-content: ${({ justify }) => (justify ? justify : 'flex-start')};
`
export const ClientListItemAvatar = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 50%;
`
export const ClientListItemText = styled(Text)`
  font-weight: 500;
  font-size: 1rem;
  line-height: 1rem;
`
export const ClientListItemActions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.675rem 0 0;

  img {
    cursor: pointer;
  }
`

//LISTCOUNT
export const ClientListCountContainer = styled.div``
export const ClientListCountText = styled(Text)`
  font-weight: 500;
  font-size: 1rem;
  line-height: 1rem;
`

//LIST PAGINATION
export const ClientListPaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const ClientListPaginationItemContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e3e4eb;
`
export const ClientListPaginationPages = styled.ul`
  width: 10rem;
  height: 2.25rem;
  background-color: #e3e4eb;
  padding: 0.4rem;
  margin: 0;
  list-style: none;
  border-radius: 4px;
  display: grid;
  align-items: center;
  justify-content: space-between;
  grid-template: 1fr / repeat(4, 1fr);
  grid-gap: 0 0.4375rem;
  box-sizing: border-box;
`
export const ClientListPaginationPage = styled.li<{ active: boolean }>`
  height: 100%;
  margin: 5px 15px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.secondary}, sans-serif;
  transition: all 0.25s ease-in-out;
  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
    padding: 0px 10px;
  }
  ${({ active, theme }) => active && ` 
    padding: 0px 10px;
    background-color: ${theme.colors.white};
  `}
`
